import axios, { Axios, AxiosRequestHeaders } from 'axios';
import authService from '../services/auth-service';
import { CacheService } from '../services/cache-service';

let instance: Axios;

const requestInterceptor = (config: any): Promise<any> => {
  if (!authService.isValidToken()) {
    authService.logOut();
  }

  if (config.headers) {
    config.headers.Authorization = `Bearer ${CacheService.get('user.accessToken')}`;
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return config;
};

export const axiosInstance = (allowFileUploads = false): Axios => {
  if (instance) {
    return instance;
  }

  const headers: AxiosRequestHeaders = {
    Authorization: `Bearer ${CacheService.get('user.accessToken')}`,
  };

  if (allowFileUploads) {
    headers['Content-Type'] = 'multipart/form-data';
  }

  instance = axios.create({
    baseURL: process.env.REACT_APP_API,
    headers,
  });

  instance.interceptors.request.use(requestInterceptor);

  return instance;
};

export const createAxiosInstance = (): Axios => {
  const instance = axios.create({
    baseURL: CacheService.get('vast.tenant.api'),
    headers: {
      Authorization: `Bearer ${CacheService.get('user.accessToken')}`,
    },
  });
  instance.interceptors.request.use(requestInterceptor);
  return instance;
};
